exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-fluid[data-v-f91f76bc]{max-height:200px}", ""]);

// exports
